<ng-container *transloco="let t; read: 'field-list'">
  <app-lex-xi-side-panel
    [isLoading]="isLoading()"
    [selectedItem]="selectedField()"
    [rightPlaceholder]="fieldsRightPlaceholder()"
    [verticalTabBarData]="[
      {
        id: 'list_view',
        icon: 'list_view',
        hasSeparator: true,
        leftSideTemplate: leftSide,
        rightSideTemplate: rightSide,
      },
    ]"
  ></app-lex-xi-side-panel>

  <ng-template #leftSide>
    <div side="left" class="field-list__list-wrapper">
      <div class="field-list__action-list-container">
        <div class="field-list__field-list-header">
          <h3>
            <span class="field-list__title"> {{ t('metadata-fields') }}</span> ({{
              displayedFields().length
            }})
          </h3>

          <div class="xi-loader-button-container">
            @if (canShowActionButtons()) {
              <div class="field-list__action-buttons-container">
                @if (showDeleteUnusedFieldsButton()) {
                  <xi-fab
                    [disabled]="isUnusedFieldsLoading() || !filteredFields().length"
                    icon="trash"
                    color="error"
                    buttonSize="normal"
                    [tooltip]="{ text: deleteUnusedFieldsTooltip(), direction: 12 }"
                    (onClick)="onDeleteUnusedFields()"
                  >
                  </xi-fab>
                }
                <xi-fab
                  icon="fab_plus"
                  buttonSize="normal"
                  color="orca"
                  [tooltip]="{ text: t('create-new-metadata-field'), direction: 12 }"
                  (onClick)="onShowNewMetadataFieldModal()"
                ></xi-fab>
              </div>
            }
            @if (isUnusedFieldsLoading()) {
              <div class="xi-loader-container__inline-overlay">
                <xi-animation
                  [height]="75"
                  [width]="75"
                  [loop]="true"
                  animation="cx_loader"
                ></xi-animation>
              </div>
            }
          </div>
        </div>

        <div>
          @if (fieldList().length && !isLoading()) {
            <div class="field-list__search-icons">
              <xi-icon-button
                #filterFieldsButton
                color="orca"
                icon="filter"
                [tooltip]="{ text: t('filter-metadata-list') }"
                (onClick)="onShowFilterFieldsPopout()"
              ></xi-icon-button>
              @if (areFiltersApplied()) {
                <xi-icon
                  class="field-list__filtering-icon"
                  icon="small_circle_filled"
                  color="CX"
                  iconSize="xxlarge"
                ></xi-icon>
              }
              <xi-dropdown
                type="icon"
                select="single"
                color="orca"
                [internalProps]="{
                  iconButton: { icon: reverseSort() ? 'sort_order_asc' : 'sort_order_desc' },
                }"
                [tooltip]="{ text: sortedTooltip() }"
                [data]="fieldsListSortData()"
                [value]="fieldsSort()"
                (onValueChange)="setSortType(+$event.detail.selected.id)"
              ></xi-dropdown>
            </div>
            <xi-list
              select="single"
              size="large"
              [hasSearch]="true"
              [hasDragging]="false"
              [hasBorder]="false"
              [internalProps]="internalProps"
              [value]="selectedField()"
            >
              <div slot="children">
                <div class="field-list__scroll-container">
                  @for (field of displayedFields(); track field.id) {
                    <div class="field-list__list-item-container">
                      <xi-list-item
                        [checked]="selectedField()?.id === field.id"
                        [attr.id]="field.id"
                        [value]="field.id"
                        (click)="onFieldClicked($event, field)"
                        [ngClass]="selectedField() === field ? 'kxi-text-600' : ''"
                      >
                        <div slot="children" class="field-list__list-item-text">
                          <div
                            class="kxi-text-normal field-list__list-item-name"
                            matTooltip="{{ field.description }}"
                          >
                            <span>{{
                              field | sideloadedLabel: 'xiFieldLabels' | truncate: 30
                            }}</span>
                            @if (field.locked) {
                              <xi-icon
                                icon="password_filled"
                                iconSize="small"
                                [tooltipProps]="{ text: t('locked-field') }"
                              ></xi-icon>
                            }
                            @if (field.groupId === GLOBAL) {
                              <xi-icon
                                icon="globe"
                                iconSize="small"
                                [tooltipProps]="{ text: t('global-field') }"
                              ></xi-icon>
                            }
                          </div>
                          <div class="field-list__item-details">
                            @if (field.modifiedAt) {
                              <p>{{ t('modified') }}:</p>
                              <p>
                                {{ field.modifiedAt | date: 'MMM dd, yyy, hh:mm a' }}
                              </p>
                            }
                            <p>{{ t('type-label') }}:</p>
                            <p>
                              @if (field.alias) {
                                <span>{{ t('alias') }} / </span>
                              }
                              {{ typeTranslations()[field.fieldType] }}
                            </p>
                          </div>
                        </div>
                      </xi-list-item>
                    </div>
                  }
                </div>
              </div>
            </xi-list>
            <xi-popout
              [isVisible]="isFilterFieldsPopoutVisible()"
              [anchorElement]="filterFieldsButton"
              [containedPopoutIds]="fieldListFilterIds"
              (onEscape)="onFilterFieldsPopoutClosed(null)"
            >
              <div slot="children">
                <app-field-list-filter
                  [fields]="fieldList()"
                  [projects]="projects()"
                  [unusedFields]="unusedFields()"
                  [popoutOpen]="isFilterFieldsPopoutVisible()"
                  (popoutClosed)="onFilterFieldsPopoutClosed($event)"
                ></app-field-list-filter></div
            ></xi-popout>
          }
          @if (!fieldList()?.length && !isLoading()) {
            <app-empty-side-panel
              emptyViewText="{{ t('empty-text') }}"
              emptyViewTitle="{{ t('empty-title') }}"
              ctaButtonText="{{ t('empty-cta-btn-text') }}"
              (ctaButtonClick)="onShowNewMetadataFieldModal()"
            >
            </app-empty-side-panel>
          }
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #rightSide>
    <div side="right">
      <router-outlet></router-outlet>
    </div>
  </ng-template>
</ng-container>

@if (showNewMetadataFieldModal()) {
  <app-lex-xi-modal
    [isVisible]="showNewMetadataFieldModal()"
    [canBackdropClose]="false"
    maxWidth="550px"
    (close)="onNewMetadataFieldModalClosed()"
  >
    <ng-template appXIModalContent>
      @if (showNewMetadataFieldModal()) {
        <app-field-create-modal
          [fields]="fieldList()"
          (modalClosed)="onNewMetadataFieldModalClosed($event)"
        ></app-field-create-modal>
      }
    </ng-template>
  </app-lex-xi-modal>
}
